/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamConstancyWorkResultDtoCreatorUser } from './BeamConstancyWorkResultDtoCreatorUser';
import {
    BeamConstancyWorkResultDtoCreatorUserFromJSON,
    BeamConstancyWorkResultDtoCreatorUserFromJSONTyped,
    BeamConstancyWorkResultDtoCreatorUserToJSON,
} from './BeamConstancyWorkResultDtoCreatorUser';
import type { BeamConstancyWorkResultDtoOutput } from './BeamConstancyWorkResultDtoOutput';
import {
    BeamConstancyWorkResultDtoOutputFromJSON,
    BeamConstancyWorkResultDtoOutputFromJSONTyped,
    BeamConstancyWorkResultDtoOutputToJSON,
} from './BeamConstancyWorkResultDtoOutput';
import type { EvaluationResultDto } from './EvaluationResultDto';
import {
    EvaluationResultDtoFromJSON,
    EvaluationResultDtoFromJSONTyped,
    EvaluationResultDtoToJSON,
} from './EvaluationResultDto';
import type { ResultHistoryEntryDto } from './ResultHistoryEntryDto';
import {
    ResultHistoryEntryDtoFromJSON,
    ResultHistoryEntryDtoFromJSONTyped,
    ResultHistoryEntryDtoToJSON,
} from './ResultHistoryEntryDto';
import type { ResultState } from './ResultState';
import {
    ResultStateFromJSON,
    ResultStateFromJSONTyped,
    ResultStateToJSON,
} from './ResultState';

/**
 * 
 * @export
 * @interface ManualTaskWorkResultDto
 */
export interface ManualTaskWorkResultDto {
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkResultDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkResultDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkResultDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ManualTaskWorkResultDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {ResultState}
     * @memberof ManualTaskWorkResultDto
     */
    state?: ResultState;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoOutput}
     * @memberof ManualTaskWorkResultDto
     */
    output?: BeamConstancyWorkResultDtoOutput | null;
    /**
     * 
     * @type {BeamConstancyWorkResultDtoCreatorUser}
     * @memberof ManualTaskWorkResultDto
     */
    creatorUser?: BeamConstancyWorkResultDtoCreatorUser | null;
    /**
     * 
     * @type {EvaluationResultDto}
     * @memberof ManualTaskWorkResultDto
     */
    evaluationResult?: EvaluationResultDto;
    /**
     * 
     * @type {Array<ResultHistoryEntryDto>}
     * @memberof ManualTaskWorkResultDto
     */
    history?: Array<ResultHistoryEntryDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ManualTaskWorkResultDto
     */
    $type?: ManualTaskWorkResultDtoTypeEnum;
}


/**
 * @export
 */
export const ManualTaskWorkResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoManualTaskWorkResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.ManualTaskWorkResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ManualTaskWorkResultDtoTypeEnum = typeof ManualTaskWorkResultDtoTypeEnum[keyof typeof ManualTaskWorkResultDtoTypeEnum];


/**
 * Check if a given object implements the ManualTaskWorkResultDto interface.
 */
export function instanceOfManualTaskWorkResultDto(value?: unknown): value is ManualTaskWorkResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ManualTaskWorkResultDtoTypeEnum)[0];
}

export function ManualTaskWorkResultDtoFromJSON(json: any): ManualTaskWorkResultDto {
    return ManualTaskWorkResultDtoFromJSONTyped(json, false);
}

export function ManualTaskWorkResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualTaskWorkResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'state': !exists(json, 'state') ? undefined : ResultStateFromJSON(json['state']),
        'output': !exists(json, 'output') ? undefined : BeamConstancyWorkResultDtoOutputFromJSON(json['output']),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : BeamConstancyWorkResultDtoCreatorUserFromJSON(json['creatorUser']),
        'evaluationResult': !exists(json, 'evaluationResult') ? undefined : EvaluationResultDtoFromJSON(json['evaluationResult']),
        'history': !exists(json, 'history') ? undefined : (json['history'] === null ? null : (json['history'] as Array<any>).map(ResultHistoryEntryDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ManualTaskWorkResultDtoToJSON(value?: ManualTaskWorkResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'state': ResultStateToJSON(value.state),
        'output': BeamConstancyWorkResultDtoOutputToJSON(value.output),
        'creatorUser': BeamConstancyWorkResultDtoCreatorUserToJSON(value.creatorUser),
        'evaluationResult': EvaluationResultDtoToJSON(value.evaluationResult),
        'history': value.history === undefined ? undefined : (value.history === null ? null : (value.history as Array<any>).map(ResultHistoryEntryDtoToJSON)),
        '$type': value.$type,
    });
}

